/* eslint-disable */
import { TextStyle } from './common.js';

export interface CaptionData {
  textStyle?: TextStyle;
}

const baseCaptionData: object = {};

export const CaptionData = {
  fromJSON(object: any): CaptionData {
    const message = { ...baseCaptionData } as CaptionData;
    message.textStyle =
      object.textStyle !== undefined && object.textStyle !== null
        ? TextStyle.fromJSON(object.textStyle)
        : undefined;
    return message;
  },

  toJSON(message: CaptionData): unknown {
    const obj: any = {};
    message.textStyle !== undefined &&
      (obj.textStyle = message.textStyle ? TextStyle.toJSON(message.textStyle) : undefined);
    return obj;
  },
};
